export const API_URL = import.meta.env.VITE_API_URL || "http://localhost:2001";

export const STORAGE_KEYS = {
  ACCESS_TOKEN: "auth_token",
  USER_DATA: "auth_user_data",
} as const;

export const SERVICE_CONFIG = {
  HRM: {
    id: "hrm",
    name: "HRM",
    icon: "Users",
    defaultUrl: "https://hrm.sdtc.vn",
  },
  PM: {
    id: "pm",
    name: "Project Management",
    icon: "BarChart3",
    defaultUrl: "https://pm.sdtc.vn",
  },
  CRM: {
    id: "crm",
    name: "CRM",
    icon: "Briefcase",
    defaultUrl: "https://crm.sdtc.vn",
  },
  MKT: {
    id: "mkt",
    name: "Marketing Ads",
    icon: "BarChart3",
    defaultUrl: "https://mkt.sdpm.vn",
  },
} as const;
